import { FormGroup } from "@angular/forms";
import { FormInlined } from "../../business-objects/form/form.model";
import { BaseObject } from "../../../core/business-objects/base-object/base-object.model";
import { getInstanceName } from "../../../core/util/get-instance-name";
export class FormResult {

    protected form: FormInlined;
    protected data: FormGroup;
    protected originalData: BaseObject;

    constructor(form: FormInlined, data: FormGroup, originalData: BaseObject) {
        this.form = form;
        this.data = data;
        this.originalData = originalData;
    }

    getForm(): FormInlined {
        return this.form;
    }

    getData(): FormGroup {
        return this.data;
    }

    getOriginalData(): BaseObject {
        return this.originalData;
    }

    getEntity(): string {
        return getInstanceName(this.getOriginalData());
    }
}



// WEBPACK FOOTER //
// ./src/vas/services/form-helper-service/form-result.ts